import React from 'react';
import MobileDownloadLink from '../../../components/MobileDownloadLink';

/**
 * Close section (#close) — final CTA.
 * The ring is a static CSS conic-gradient (not the paid morph plugin),
 * kept as decoration. iOS + Android buttons match Hero/Founding.
 */

const IOS_URL = 'https://apps.apple.com/us/app/kachng-digital-receipt/id6502332854';
const ANDROID_URL = 'https://play.google.com/store/apps/details?id=com.Gibbas.KACHNG';

export default function Close({ mobile = false }) {
  return (
    <section id="close">
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          textAlign: 'center',
          padding: 'clamp(64px,9vw,112px) clamp(20px,5vw,56px)',
          position: 'relative',
          overflow: 'hidden',
        }}
      >
        {/* Static decorative ring */}
        <div
          aria-hidden="true"
          style={{
            position: 'absolute',
            width: 'min(600px,120vw)',
            height: 'min(600px,120vw)',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%,-50%)',
            borderRadius: '50%',
            background: 'conic-gradient(#1F7A4D 0deg 275deg, #0E2C1B 275deg 360deg)',
            WebkitMask:
              'radial-gradient(farthest-side, transparent calc(100% - 64px), #000 calc(100% - 63px))',
            mask: 'radial-gradient(farthest-side, transparent calc(100% - 64px), #000 calc(100% - 63px))',
            opacity: 0.34,
            filter: 'blur(5px)',
            pointerEvents: 'none',
          }}
        />

        <div style={{ position: 'relative', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
          <h2
            data-rv="up"
            style={{
              margin: '0 0 32px',
              fontSize: 'clamp(32px,4vw,52px)',
              fontWeight: 800,
              letterSpacing: '-0.025em',
              maxWidth: '20ch',
              textWrap: 'balance',
            }}
          >
            Start remembering every purchase.
          </h2>

          {mobile ? <MobileDownloadLink source="final" /> : <div data-rv="up" style={{ display: 'flex', gap: '12px', flexWrap: 'wrap', justifyContent: 'center', marginBottom: '16px' }}>
            <a
              href={IOS_URL}
              target="_blank"
              rel="noopener noreferrer"
              style={{
                background: 'var(--kachng-green)',
                color: 'var(--bg-ink)',
                fontWeight: 700,
                fontSize: '17px',
                padding: '18px 40px',
                borderRadius: '8px',
                whiteSpace: 'nowrap',
                minHeight: '44px',
                boxSizing: 'border-box',
              }}
            >
              Download for iOS
            </a>
            <a
              href={ANDROID_URL}
              target="_blank"
              rel="noopener noreferrer"
              style={{
                background: 'var(--green-accent-bg)',
                color: 'var(--kachng-green)',
                fontWeight: 700,
                fontSize: '17px',
                padding: '18px 40px',
                borderRadius: '8px',
                whiteSpace: 'nowrap',
                minHeight: '44px',
                boxSizing: 'border-box',
              }}
              onMouseEnter={(e) => (e.currentTarget.style.background = 'var(--green-accent-bg-hi)')}
              onMouseLeave={(e) => (e.currentTarget.style.background = 'var(--green-accent-bg)')}
            >
              Download for Android
            </a>
          </div>}

          <div data-rv="up" style={{ fontSize: '14px', color: 'var(--text-muted)' }}>
            Free to start. Takes 30 seconds.
          </div>
        </div>
      </div>
    </section>
  );
}